// Using Simple Icons CDN for consistent, high-quality SVG icons
const ICON_BASE_URL = "https://cdn.simpleicons.org";
const DEFAULT_SIZE = 128;

export function generateIconUrl(platform: keyof typeof socialIcons, color: string, size: number = DEFAULT_SIZE): string {
  if (platform === 'bitcoin') {
    return `${ICON_BASE_URL}/bitcoin/${color}?size=${size}`;
  }
  if (platform === 'ethereum') {
    return `${ICON_BASE_URL}/ethereum/${color}?size=${size}`;
  }
  return `${ICON_BASE_URL}/${platform}/${color}`;
}

export const socialIcons = {
  x: true,
  instagram: true,
  facebook: true,
  linkedin: true,
  github: true,
  tiktok: true,
  youtube: true,
  twitch: true,
  bluesky: true,
  bitcoin: true,
  ethereum: true
} as const;